
import React, { useEffect, useState } from 'react';
import { Button } from "@material-ui/core";
import ChatMidGradient from '../../assets/img/chatMidGradient';
import ConsultantMidGradient from '../../assets/img/consultantMidGradient';
import CloseSystem from "../../assets/img/closeSystem";
import voWhatsappQr from "../../assets/img/vo-whatsapp-qr.png"
import '../../styles/App.css';
import './flyout.scss';
import ChatMid from "../../assets/img/chatMid";
import ConsultantMid from "../../assets/img/consultantMid";

export function Flyout({ setPopupOverflow }) {
  const [popUp, setPopUp] = React.useState(false);
  const [type, setType] = useState('');
  const [btn1, setbtn1] = React.useState("flybtn button-top-margin");
  const [btn2, setbtn2] = React.useState("flybtn button-bottom-margin");
  const [consultantFlybtn, setConsultantflybtn] = React.useState("consultant-flybtn");
  const [chatFlybtn, setChatflybtn] = React.useState("consultant-flybtn");
  const [consultantPopUp, setConsultantPopUp] = React.useState(false);
  const [chatPopUp, setChatPopUp] = React.useState(false);
  const whatsAppUrl = "https://api.whatsapp.com/send/?phone=491721217212&text=Hallo+Vodafone-Team%2C+ich+war+auf+der+Vodafone+Website+und+habe+noch+Fragen&app_absent=0";

  function showPopUp(type) {
    setType(type);
    setPopUp(true);
    setPopupOverflow("scrollHidden")
  }
  function hidePopup() {
    setPopUp(false);
    setChatPopUp(false);
    setConsultantPopUp(false);
    setbtn1("flybtn button-top-margin");
    setConsultantflybtn("consultant-flybtn");
    setbtn2("flybtn button-bottom-margin");
    setChatflybtn("consultant-flybtn");
    setPopupOverflow("scrollVisible")
  }
  function showConsultantPopUp(type) {
    showPopUp(type);
    setType(type);
    setConsultantPopUp(true);
    setbtn1("flybtn-original button-top-margin");
    setConsultantflybtn("consultant-flybtn-original");
    setbtn2("flybtn button-bottom-margin");
    setChatflybtn("consultant-flybtn");
  }
  function showChatPopUp(type) {
    showPopUp(type);
    setType(type);
    setChatPopUp(true);
    setbtn2("flybtn-original button-bottom-margin");
    setChatflybtn("consultant-flybtn-original");
    setbtn1("flybtn button-top-margin");
    setConsultantflybtn("consultant-flybtn");
  }
  function showMobilePopUp(type) {
    showPopUp(type);
    setType(type);
  }
  function showMobileConsulatantPopup(type) {
    setType(type);
  }

  function showMobileChatPopup(type) {
    setType(type);
  }
  function hideMobilePopup(type) {
    setType(type);
  }

  return (
    <div style={{ background: popUp && 'rgba(51,51,51,0.6)' }} className="flyout-parent">
      <div className={`container ${popUp ? 'transform' : ''}`}>
        <div className={`buttons ${!popUp && 'show-buttons'}`}>
          <Button className={btn1} variant="contained" onClick={showConsultantPopUp.bind(this, 1)}><ConsultantMidGradient className={consultantFlybtn} /></Button>
          <Button className={btn2} variant="contained" onClick={showChatPopUp.bind(this, 2)}><ChatMidGradient className={chatFlybtn} /></Button>
          <Button className="mobile-button" variant="contained" onClick={showMobilePopUp.bind(this, 3)}><ConsultantMidGradient className="consultant-flybtn" /></Button>
          <Button className="kontakt-button" variant="contained" onClick={showMobilePopUp.bind(this, 3)}>Kontakt</Button>
        </div>
        <div className={`sidebar`}>
          <button className="close-button" onClick={hidePopup}><CloseSystem></CloseSystem></button>
          {type == 1 && <div className={'type1'}>
            <div className="dialog-margin">
              <div className="contentStyleTitle">Beratung & </div>
              <div className="contentStyleTitle">Bestellung</div>
              <div className="contentStyleLine1 dialog-margin-top">Du möchtest etwas</div>
              <div className="contentStyleLine1">bestellen?</div>
              <div className="contentStyleLine2 dialog-margin-top">Wir beraten Dich gern.</div>
              <div className="contentStyleLine3 dialog-margin-top">Mo-Fr: 08-22 Uhr, Sa-So: 09- 17 Uhr</div>
              {/* <Button className="button-style" variant="contained"><a className="call-link" href="tel:+49-800-4440660399">0800 444066 0399</a></Button> */}
              <a className="call-link" href="tel:+49-800-4440660399"><Button className="button-style" variant="contained">0800 444066 0399</Button></a>
            </div>
          </div>}
          {type == 2 && <div className={'type2'}>
            <div className="dialog-margin">
              <div className="contentStyleTitle">Kundenbetreuung </div>
              <div className="contentStyleLine1 dialog-margin-top">Hast Du Fragen xu Deinem</div>
              <div className="contentStyleLine1">Vertrag?</div>
              <div className="contentStyleLine3 dialog-margin-top">Wir sind jeden Tag für Dic da</div>
              <div className="contentStyleLine3 dialog-margin-top dialog-margin-top">Scanne bitte diesen QR-Code mit der Kamera Deines</div>
              <div className="contentStyleLine3">Mobilgeräts ein. Geht nicht? Dann verwende bitte eine QR-</div>
              <div className="contentStyleLine3">Scanner-App.</div>
              <img className="whatsappQr dialog-margin-top" src={voWhatsappQr}></img>
              <div className="contentStyleLine3 dialog-margin-top">Oder unterstützt Dein Browser WhatsApp Web? Dann kannst</div>
              <div className="contentStyleLine3">Du das Gespräch auch gleich über Deinen Computer starten:</div>
              <a className="call-link" href={whatsAppUrl}><Button className="button-style" variant="contained">Auf WhatsApp Web starten</Button></a>
            </div>
          </div>}
          {type == 3 && <div className={'type3'}>
            <div className="dialog-margin">
              <div className="mobilepopup-title">Unser Beratungs-Angebot</div>
              <div className="mobilepopup-line1 dialog-margin-top">Wie können wir Dir helfen?</div>
              <button className="mobileButtonStyle" onClick={showMobileConsulatantPopup.bind(this, 4)}>
                <ConsultantMid className="popup-button"></ConsultantMid>
                <div className="buttonText">Ruf uns kostenlos an</div>
              </button>
              <button className="mobileButtonStyle" onClick={showMobileChatPopup.bind(this, 5)}>
                <ChatMid className="popup-button"></ChatMid>
                <div className="buttonText">Schreib uns bei WhatsApp</div>
              </button>
            </div>
          </div>
          }
          {type == 4 && <div className={'type4'}>
            <div className="dialog-margin">
              <div className="mobilePopupTitle">Beratung & Bestellung</div>
              <div className="mobilePopupLine1">Du möchtest etwas bestellen?</div>
              <div className="dialog-margin-top"></div>
              <div className="mobilePopupLine2">Wir beraten Dich gern.</div>
              <div className="mobilePopupLine2">Mo-Fr: 08-22 Uhr, Sa-So: 09-17 Uhr</div>
              <a className="call-link" href="tel:+49-800-4440660399"><Button className="button-style" variant="contained">0800 444066 0399</Button></a>
              <div className="dialog-margin-top"></div>
              <Button className="back-button" variant="contained" onClick={hideMobilePopup.bind(this, 3)}>Zurück</Button>
            </div>
          </div>
          }
          {type == 5 && <div className={'type5'}>
            <div className="dialog-margin">
              <div className="mobilePopupTitle">Kundenbetreuung</div>
              <div className="mobilePopupLine1">Hast Du Fragen zu Deinem</div>
              <div className="mobilePopupLine1">Vertrag?</div>
              <div className="dialog-margin-top"></div>
              <div className="mobilePopupLine2">Wir sind jeden Tag für Dich da.</div>
              <a className="call-link" href={whatsAppUrl}><Button className="button-style" variant="contained">Chat in WhatsApp öffnen</Button></a>
              <div className="dialog-margin-top"></div>
              <Button className="back-button" variant="contained" onClick={hideMobilePopup.bind(this, 3)}>Zurück</Button>
            </div>
          </div>
          }
        </div>
      </div>
    </div>
  )
}